import React from "react";

import pkg from "../../lib/pkg";
import { AnalyticsError } from "../../lib/util";
import { IntegrationCategory } from "../../providers/AnalyticsContext";
import useTrackEvent from "../useTrackEvent";

const EVENT_NAME = "Products Searched";

interface ProductsSearchedProperties {
  query: string;
}

export default function useProductsSearched() {
  const trackAdEvent = useTrackEvent(IntegrationCategory.Advertising);

  function track(properties: ProductsSearchedProperties) {
    try {
      trackAdEvent(EVENT_NAME, properties);
    } catch (error) {
      pkg.onError(new AnalyticsError(EVENT_NAME, error));
    }
  }

  return React.useCallback(track, [trackAdEvent]);
}
